import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import CustomFormPageTitleAndDescription from '@/common/CustomFormPageTitleAndDescription/CustomFormPageTitleAndDescription';
import { useWebformStore } from '@/stores/WebformStore';
import './SuccessPage.scss';

interface SuccessPageProps {
  title: string;
  description: string;
  isStandaloneForm: boolean;
  steps: { title: string }[];
  activeStep: number;
  goBackToSelectedStep: (step: number) => void;
}

const SuccessPage = ({
  title,
  description,
  isStandaloneForm,
  steps,
  activeStep,
  goBackToSelectedStep,
}: SuccessPageProps) => {
  //////////////////////////////
  // Webform Store
  //////////////////////////////

  const [requestId] = useWebformStore(useShallow(state => [state.requestId]));

  //////////////////////////////

  return (
    <Flex className={'success-page-container'}>
      <CustomFormPageTitleAndDescription
        title={title}
        description={description}
        isStandaloneForm={isStandaloneForm}
        steps={steps}
        activeStep={activeStep}
        goBackToSelectedStep={goBackToSelectedStep}
      />

      <Flex className={'request-id-label-and-value-container'}>
        <span className={'request-id-label'}>Request ID:</span>
        <span className={'request-id-value'}>{requestId}</span>
      </Flex>
    </Flex>
  );
};

export default SuccessPage;
